import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If your content is `}<strong parentName="p">{`legal`}</strong>{` under U.S. law, then you are in good standing. That is the benchmark.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      